module.exports = __webpack_public_path__ + "static/img/wuxi.b08345c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/wuxi.jpg
// module id = ha31
// module chunks = 1